<template>
  <div v-if="buoyImage" 
    class="client-item-box buoy"
    :class="{'buoy-article': pageType==='article'}" 
    :style="stylObj"
    :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex"
    :data-trackdata="tData"
    @click="buoyAction">
    <img :src="buoyImage">
    <!-- <div 
      v-if="pageType === 'index'" 
      class="buoy-box" 
      :style="{'width': `${imageWidth}px`, 'height': `${data.height*ratio}px`, 'bottom': `${imageBottom}px`, 'right': `${data.right*ratio}px`}" 
      @click="buoyAction">
      <img :src="buoyImage">
    </div>
    <div 
      v-if="pageType === 'article'" 
      class="buoy-box buoy-article-box" 
      :style="{'width': `${imageWidth}px`, 'height': `${data.height*ratio}px`, 'right': `${data.right*ratio}px`}" 
      @click="buoyAction">
      <img :src="buoyImage">
    </div> -->
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'
import { isIphoneX } from '@/util'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'buoy',
  props: ['data', 'modIndex', 'memberTags', 'sdk', 'miniEnv', 'isApp', 'pageType'],
  components: {
  },
  data () {
    return {
      ratio,
      buoyImage: null,
      imageWidth: 0,
      imageBottom: 0,
      stylObj: null,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted() {
  },
  computed: {
  },
  created() {
    this.formatData()
  },
  methods: {
    formatData () {
      console.log('buoy', this.pageType)
      const ratio = this.ratio
      const tags = this.memberTags || []
      if((this.data.customer !== 'ALL' && this.data.customer !== 'DELINEATION' && tags.indexOf(this.data.customer) === -1) || (this.data.customer === 'DELINEATION' && tags.indexOf(this.data.customerCode) === -1)) {
        return
      }

      this.buoyImage = ensure_protocol(this.data.image.src)
      // this.imageWidth = (this.data.image.width/3)*this.ratio

      const iphoneX = isIphoneX()
      let navbarHeight = 50*ratio
      if(iphoneX) {
        navbarHeight = 84*ratio
      }

      const imageWidth = (this.data.image.width/3)*this.ratio
      const imageHeight = (this.data.image.height/3)*this.ratio
      
      if(this.pageType === 'index') {
        this.imageBottom = this.data.bottom*this.ratio+navbarHeight
        this.stylObj = {
          'width': `${imageWidth}px`,
          'height': `${imageHeight}px`,
          'bottom': `${this.imageBottom}px`,
          'right': `${this.data.right*ratio}px`
        }
      }
      if(this.pageType === 'article') {
        // this.imageBottom = articleBottom
        this.imageBottom = 0
        this.stylObj = {
          'width': `${imageWidth}px`,
          'height': `${imageHeight}px`,
          'right': `${this.data.right*ratio}px`
        }
      }

      
    },

    buoyAction () {
      const link = this.data.link
      if(!link.type || link.type === 'none') {
        return
      }

      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && this.data.toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link,
                isMini: this.miniEnv
              })
      }
      
      const trackData = this.data.trackData
      // trackData.operation_module_number = -1
      trackAction({
        trackData,
        pageObj: getLinkPageData({
          link
        })
      })
      // console.log(trackData, '#######')

      normalSkip({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// buoy.vue?0f4469e3